import * as util from "../../../common/m_base/util"
import BigTemplate from '../BigTemplate.js'
import VideoTemplateLegacy from "../VideoTemplateLegacy";
import EndCardTemplate from "../EndCardTemplate"
import {
    getEndScreenInfo,
    VideoBridgeInit,
    customCommand,
    VideoBridgeReadyStatusHasReady,
    VideoBridgeShowVideoLocation,
    VideoBridgeVideoOperatePlay,
    RewardJsToggleCloseBtnShow,
    VideoBridgeReadyStatusNotReady, onComponentReactPreloadURLFinished
} from "../../../api";
import Webview from "../../component/native/visible/Webview"

/**
 * mintegral SDK 大模板
 */
export default class BigTplChooseFromTwoLegacy extends BigTemplate {
    constructor(props = {}) {
        super(props)

        const unit = props.unit
        this.unit = unit

        this.templateName = props.templateName || 'mtg_unknown_big_template'

        this._allTplPreloadFinishedListener = []
        this._preloadFailureListener = []


        this.webview = undefined

        this.initComponents()
    }

    show(res) {
        super.show()
    }

    initComponents() {
        Webview.getInstance().then(webview=>{
            this.webview = webview
        })
        this.webview = new Webview()
    }


    setSubTpls(campaignList, tplClass){
        const tplInstance = new tplClass()
        campaignList.forEach((campaign)=>{
            const params = {
                campaign,
                unitid: this.unit.id,
                unitsetting: this.unit.setting
            }
            tplInstance.create(params).then((res={})=>{
                const { code, data } = res
                if (code === 0) {
                    const cmpt = this._getVideoTplNativeCmpt(campaign, data.cmpt)
                    console.warn('创建 Native 播放模板成功: ', {res})
                    // 关联 campaign 和 原生组件
                    this.tplIndexList.push(cmpt)
                    this._preload(cmpt, tplInstance)
                } else {
                    console.warn('创建 Native 播放模板失败: ', {res})
                }
                //vt.init(campaign, data)
                this.campaignList.push(campaign)
                //this.addVideoTpl(videoTpl)
            }).catch(err => {
                console.warn('创建 Native 播放模板异常: ', {err})
                VideoBridgeReadyStatusNotReady()
            })
        })
    }

    _getVideoTplNativeCmpt(campaign, cmptInstance){
        const cmpt = {
            campaignId: campaign.id,
            tplInstance: cmptInstance,
            isPageLoadFinished: false,
        }
        return cmpt
    }

    _preload(cmpt, tplInstance){
        // preload finish 回调
        onComponentReactPreloadURLFinished({
            cmpt ,
            cb: async () => {
                console.log(cmpt.campaignId, cmpt.tplInstance.id, 'preload finish 触发, 当前 load 状态:', cmpt.isPageLoadFinished, {curTplIndex: cmpt})
                cmpt.isPageLoadFinished = true

                // 判断如果所有模板都 preload 成功, 则执行下一步 (addSubView/回调 SDK ready)
                if (this.isAllTplPreloadFinished()) {

                    // 检查所有模板是否都已经 preload finished, 如果是则通知 SDK ready
                    this._noticeAllTplPreloadFinished()

                    // 如果可以获取父视图 "大模板" 的实例, 则开始 addSubView
                    if (this.webview) {
                        let addRes = await addVideoTemplateLegacy({
                            parentCmpt: this.webview,
                            childCmpt: cmpt.tplInstance
                        }).catch(err => {
                            console.warn({err})
                        })
                        console.log({addRes})
                    } else {
                        console.warn('大模板实例获取失败')
                    }

                }
            }
        })

        console.log(cmpt.campaignId, cmpt.tplInstance.id, 'preload 开始: ', {curTplIndex: cmpt})

        tplInstance
            .preload({cmpt: cmpt && cmpt.tplInstance})
            .then((preloadRes)=>{
                console.log(cmpt.campaignId, cmpt.tplInstance.id, 'preload 完毕: ', {preloadRes}, {curTplIndex: cmpt})
                if (preloadRes && preloadRes.code === 0) {
                    console.log(cmpt.campaignId, cmpt.tplInstance.id, 'preload 调用成功----------', {preloadRes})
                } else {
                    console.warn(cmpt.campaignId, cmpt.tplInstance.id, 'preload 失败', {preloadRes})
                    this._noticePreloadFailure()
                }
            })
            .catch(err => {
                console.warn(cmpt.campaignId, cmpt.tplInstance.id, 'preload 异常', {err})
                this._noticePreloadFailure()
            })
    }

    isAllTplPreloadFinished() {
        let isAllFinished = true
        for (let curTplItem of this.tplIndexList) {
            if (curTplItem.isPageLoadFinished === false) {
                isAllFinished = false
            }
        }
        return isAllFinished
    }

    onAllTplPreloadFinished(cb) {
        this._allTplPreloadFinishedListener.push(cb)
    }
    _noticeAllTplPreloadFinished() {
        this._allTplPreloadFinishedListener.forEach(cb=>{
            cb && ('function' === typeof cb) && cb()
        })
    }
    onPreloadFailure(cb) {
        this._preloadFailureListener.push(cb)
    }
    _noticePreloadFailure() {
        this._preloadFailureListener.forEach(cb=>{
            cb && ('function' === typeof cb) && cb()
        })
    }

    renderPage() {
        console.log('renderPage: ')
        let res = getEndScreenInfo()
        console.log('getEndScreenInfo(): ', {res})
    }

    bindEvent() {
        console.log('bindEvent: ')
    }

    showVideo(res) {
        console.log('showVideo: window.WindVane.call(\'VideoBridge\', \'showVideoLocation\', {', res)
        VideoBridgeShowVideoLocation({
            "margin_top": 0, // document.documentElement.clientHeight * .22,
            "margin_left": 0, // document.documentElement.clientWidth - 180,
            "view_width": 160,
            "view_height": 90,
            "radius": 10
        })
    }

    playVideo(res) {
        console.log('playVideo: ')
        VideoBridgeVideoOperatePlay()
    }

    initCloseButton(res) {
        let close_button_delay = 6000
        console.log('initCloseButton: ', {close_button_delay})
        setTimeout(() => {
            RewardJsToggleCloseBtnShow()
        }, close_button_delay)
    }

    install(campaign) {
        console.log('BigTemplateDefault class method: install')
    }

    async customCommand({fnName, params}) {
        return await customCommand({fnName, params})
    }
}